var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat1NewHair2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hats_new-hair-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat1_6_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M509.9,195.7l-1.2-18.4c-1.6-16.8-1-19.8-8.4-22.2c-1.4-0.4-2.8-0.8-4.3-1.3c-21.1-6.3-43-10.7-65.3-13.6 c-4-0.5-8-1-11.9-1.4c-32.7-4.6-66.1-6.5-99.9-4.9c-4.2,0.2-8.4,0.4-12.7,0.7c-36.8,2.9-73.1,9.4-106.4,22.1 c-1.5,0.6-3.1,1.2-4.6,1.8c-3.4,1.4-12.2,0.1-4.7,51.6l0.2,3.7c1.7,10.2,7,12,12.3,10.3c0.4-0.1,0.8-0.3,1.2-0.4 c2.2-0.7,4.5-1.4,6.7-2.1c16.5-4.8,33.3-8.4,50.4-11.1c8.6-1.4,17.2-2.5,25.9-3.4c40.9-3.9,81.6-4.5,121.8-1.3 c8,0.6,16,1.4,23.9,2.4c15.6,2,31,4.7,46.1,8.4C494.8,220.4,512.3,227.9,509.9,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC202F",
    d: "M318.9,134c33.8-1.6,67.2,0.3,99.9,4.9c4,0.4,8,0.9,11.9,1.4c22.3,2.8,44.2,7.3,65.3,13.6 c0.1-2.8,0.1-5.6,0-8.5c-0.1-3.6-0.5-7.1-1-10.7c-3.8-25.9-17.5-52.7-41.1-70.8c-3.4-2.6-7-5-10.7-7.2 c-20-12.2-44.1-16.9-68.9-17.8c-4.1-0.2-8.3-0.2-12.4-0.2C318,39.8,269.5,44.8,237,71.4c-3.4,2.6-6.6,5.4-9.5,8.3 C206,101,198.2,129,200,156.7c33.2-12.7,69.6-19.2,106.4-22.1C310.5,134.4,314.7,134.2,318.9,134z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M490.6,149.1c-2.9-1.1-5.8-2.1-8.7-3.2c-19.5-6.7-39.9-12-60.7-16c-4.2-0.8-8.4-1.6-12.6-2.3 c-46.2-7.7-93.5-8-139.9-2.4c-4.2,0.5-8.4,1.1-12.5,1.8c-8.3,1.4-16.4,3.1-24.3,5.4c3.5-33.7,24.9-65.9,58.4-85.6 c0.2-0.1,0.4-0.2,0.5-0.3c-20.1,4.8-38.8,12.5-54,25c-3.4,2.6-6.6,5.4-9.5,8.3c-21.5,21.3-29.3,49.3-27.5,77 c33.2-12.7,69.6-19.2,106.4-22.1c4.2-0.3,8.5-0.6,12.7-0.7c33.8-1.6,67.2,0.3,99.9,4.9c4,0.4,8,0.9,11.9,1.4 c22.3,2.8,44.2,7.3,65.3,13.6c0-0.9,0-1.8,0.1-2.7C494.3,150.5,492.5,149.8,490.6,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA191F",
    d: "M222.4,197.7c7.5-15.7,16.1-32,8.5-50.8c-10.6,2.8-21,6.1-31.1,9.9c-1.5,0.6-3.1,1.2-4.6,1.8 c-3.4,1.4-12.2,0.1-4.7,51.6l0.2,3.7c1.7,10.2,7,12,12.3,10.3c0.4-0.1,0.8-0.3,1.2-0.4c2.2-0.7,4.5-1.4,6.7-2.1 c5.6-1.6,11.2-3.1,16.9-4.4C224.5,210.8,220.1,203.7,222.4,197.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M350.5,27.7c-13.6-6.7-29.2,2.3-31.6,13.9c12.9-1.6,26-2.3,38.7-2.7C356.7,34.7,355.4,30,350.5,27.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M305.4,138.3c4.2-0.3,8.5-0.6,12.7-0.7c33.8-1.6,67.2,0.3,99.9,4.9c4,0.4,8,0.9,11.9,1.4 c26.4,3.3,52.3,9,76.9,17.2c-1-3.3-2.7-4.7-6.5-5.9c-1.4-0.4-2.8-0.8-4.3-1.3c-7.8-2.3-15.6-4.4-23.6-6.2l-0.5-7.8 c-4.8-33.9-19.8-62.3-48.3-86.1c28.3,24.2,40.6,53.2,45.2,86.3l0.5,6.8c-12.6-2.8-25.4-5-38.4-6.6l-0.9-7.2 c-5.4-32.3-17.6-58.8-37.3-86c19.5,27.5,29.1,54.5,34.3,86.4l0.8,6.5c-3-0.4-6-0.7-8.9-1c-11.3-1.6-22.8-2.9-34.3-3.8l-0.5-6.7 c-2.4-29.7-4.7-55.6-16.9-83.2C379,73.1,378.7,99,381,128.7l0.5,6.2c-11.9-0.9-23.8-1.4-35.8-1.4l-0.1-6.4 c-0.6-28.6-3.8-52.8-9.1-80.4c4.9,27.7,5.5,52,6,80.4l0.1,6.3c-7.8,0-15.7,0.2-23.6,0.5c-4.2,0.2-8.4,0.4-12.7,0.7 c-1.6,0.1-3.3,0.3-4.9,0.4l-0.6-5.8c-2.6-28.3-3.2-53.3,9-79.8c-12.6,26.3-14.6,51.5-12.1,80c0.2,2,0.4,3.9,0.6,5.8 c-13,1.2-25.9,2.9-38.6,5.2c-0.4-1.8-0.8-3.7-1.1-5.5c-3.4-26.4,0.1-49.9,11.7-74.6c-12,24.4-18.2,47.8-14.8,74.9 c0.2,2,0.7,3.9,1.1,5.8c-8.7,1.6-17.2,3.5-25.6,5.7c-0.3-1.6-0.6-3.3-0.7-4.9c-2.3-24.3,2-45.5,10.7-68.6 c-9,22.9-16,43.8-13.8,68.9c0.1,1.9,0.5,3.7,0.8,5.5c-9.6,2.6-19,5.6-28.1,9.1c-1.5,0.6-3.1,1.2-4.6,1.8c-1.6,0.6-4.3,0.7-6,5.7 c3.6-1.5,7.2-3,10.9-4.4C233.1,147.5,269,141.2,305.4,138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M409.5,201.6c-40.2-3.2-80.9-2.6-121.8,1.3c-8.7,0.9-17.4,2.1-25.9,3.4c-17.1,2.7-33.9,6.4-50.4,11.1 c-2.7,0.8-5.3,1.6-8,2.5c-2.9,1-5.7,2-8.5,3.1c2.3,2,5.2,2.1,8.1,1.2c0.4-0.1,0.8-0.3,1.2-0.4c2.2-0.7,4.5-1.4,6.7-2.1 c16.5-4.8,33.3-8.4,50.4-11.1c8.6-1.4,17.2-2.5,25.9-3.4c40.9-3.9,81.6-4.5,121.8-1.3c8,0.6,16,1.4,23.9,2.4 c15.6,2,31,4.7,46.1,8.4c8.7,2.1,18,5.3,24.1,2.3c-22.4-7-45.9-11.9-69.8-14.9C425.5,203,417.5,202.2,409.5,201.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M222,211.5c-8.3-17.6-7.1-33.8-6.4-51.4c-0.2,17.8,2.5,33.5,10.6,50l2.3,4.4l-4.1,1.6L222,211.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M251.6,205.1c-6.8-18-8.3-34.2-5.8-52.2c-1.8,18.1,3.4,33.8,10.1,51c0.6,1.6,1.4,3,2.1,4.6l-4.2,1.4 C253.1,208.3,252.3,206.8,251.6,205.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M285.9,200.3c-4.9-18.3-7-34.4-6.4-52.7c0.1,18.4,5.8,33.8,10.9,51.8l1.4,4.8l-4.4,0.9L285.9,200.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M323.3,197.4c-4.1-18.8-2.3-35.2,0.4-53.4c-2,18.4-0.1,34.5,4.1,52.7l1.2,4.9l-4.4,0.9L323.3,197.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M362.2,196.3c3-18.8,5.5-35,2.9-53.6c3.3,18.4,4.6,35,1.7,54.1l-0.9,5.1l-4.5-0.5L362.2,196.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M405.4,198.6c4.5-18.3,6.4-34.7,1.9-53c5.1,18,7,34.7,2.6,53.7l-1.4,5.1l-4.4-0.9L405.4,198.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M447.6,203.8c2.9-17.5,4.1-32.9,0-50.2c4.8,17,7.3,32.6,4.6,50.6l-0.9,4.8l-4.5-0.6L447.6,203.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#96171B",
    d: "M478.2,208.9c4-16.9,7-31.8,5-48.9c2.6,16.9,3.3,32.1-0.6,49.6l-1.2,4.7l-4.4-0.8L478.2,208.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M293.8,54.6c-0.4,1.7-1.6,3-2.6,2.9c-1.1-0.1-1.6-1.7-1.2-3.4s1.6-3,2.6-2.9 C293.6,51.3,294.1,52.9,293.8,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M283.5,80.7c-0.3,1.4-1.3,2.5-2.2,2.4c-0.9-0.1-1.3-1.4-1-2.8s1.3-2.5,2.2-2.4 C283.4,78,283.8,79.3,283.5,80.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M242.9,112.7c-0.3,1.4-1.3,2.5-2.2,2.4s-1.3-1.4-1-2.8s1.3-2.5,2.2-2.4 C242.7,110,243.2,111.2,242.9,112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M237.8,196.2c0.1,1.4-0.6,2.6-1.5,2.7c-0.9,0-1.7-1.1-1.8-2.6c-0.1-1.4,0.6-2.6,1.5-2.7 C237,193.6,237.8,194.7,237.8,196.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M269.3,152.1c0.1,1.7-0.7,3.2-1.8,3.2s-2-1.3-2.1-3.1c-0.1-1.7,0.7-3.2,1.8-3.2 C268.3,149,269.2,150.4,269.3,152.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M267,193c0.5,1.7,0,3.2-1,3.4s-2.3-1-2.7-2.7c-0.5-1.7,0-3.2,1-3.4S266.5,191.3,267,193z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M301.8,172.9c0.3,1.7-0.2,3.2-1.3,3.3c-1.1,0.1-2.2-1.1-2.5-2.8s0.2-3.2,1.3-3.3 C300.3,170,301.5,171.2,301.8,172.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M313.5,145.1c0,1.7-0.9,3.1-2,3.1s-1.9-1.4-1.9-3.1c0-1.7,0.9-3.1,2-3.1S313.6,143.4,313.5,145.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M344.1,148.4c0,1.7-0.9,3.1-2,3.1s-1.9-1.4-1.9-3.1c0-1.7,0.9-3.1,2-3.1 C343.3,145.3,344.1,146.7,344.1,148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M339.8,188.3c0,1.7-0.9,3.1-2,3.1s-1.9-1.4-1.9-3.1c0-1.7,0.9-3.1,2-3.1 C339,185.1,339.8,186.5,339.8,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M385.4,160.2c0,1.7-0.9,3.1-2,3.1s-1.9-1.4-1.9-3.1c0-1.7,0.9-3.1,2-3.1 C384.5,157.1,385.4,158.5,385.4,160.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M390.8,190.3c-0.3,1.7-1.3,3-2.4,2.9s-1.7-1.6-1.4-3.3c0.3-1.7,1.3-3,2.4-2.9 C390.4,187.1,391,188.6,390.8,190.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M435,183.3c-0.3,1.7-1.3,3-2.4,2.9s-1.7-1.6-1.4-3.3c0.3-1.7,1.3-3,2.4-2.9 C434.6,180.1,435.2,181.5,435,183.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M465.2,164.5c0,1.7-0.8,3.1-1.9,3.2c-1.1,0-2-1.4-2-3.1c0-1.7,0.8-3.1,1.9-3.2 C464.3,161.4,465.2,162.8,465.2,164.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M468.4,198.8c-0.1,1.7-1.1,3.1-2.2,3c-1.1,0-1.8-1.5-1.7-3.2c0.1-1.7,1.1-3.1,2.2-3 C467.8,195.7,468.5,197.1,468.4,198.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M496.6,167.5c0,2.2-1.1,3.9-2.4,3.9s-2.4-1.7-2.4-3.9s1.1-3.9,2.4-3.9S496.6,165.4,496.6,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M275.3,111.6c-0.2,1.5-1.2,2.7-2.1,2.6s-1.5-1.4-1.3-2.9s1.2-2.7,2.1-2.6 C275,108.8,275.6,110.1,275.3,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M253.2,72.2c-0.9,1.8-2.5,3-3.6,2.7s-1.3-2.1-0.5-3.9c0.9-1.8,2.5-3,3.6-2.7S254,70.4,253.2,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M221.7,111.9c-0.5,1.9-1.9,3.3-3.1,3.1c-1.2-0.2-1.7-1.9-1.2-3.8s1.9-3.3,3.1-3.1 C221.7,108.3,222.2,110,221.7,111.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M213.4,136.3c0,1.9-1,3.5-2.2,3.5s-2.1-1.6-2.1-3.5s1-3.5,2.2-3.5C212.5,132.8,213.4,134.3,213.4,136.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M203.2,187.9c0,1.9-1,3.5-2.2,3.5s-2.1-1.6-2.1-3.5s1-3.5,2.2-3.5C202.3,184.4,203.3,186,203.2,187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M230.5,169.1c0,1.8-0.9,3.2-2,3.2s-1.9-1.4-1.9-3.2s0.9-3.2,2-3.2C229.7,165.9,230.6,167.3,230.5,169.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4AAAB",
    d: "M204.4,213c0.4,1.5,0,2.8-0.9,3s-1.9-0.9-2.3-2.4c-0.4-1.5,0-2.8,0.9-3C203,210.4,204,211.5,204.4,213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M318.6,70.2c0,1.5-0.7,2.8-1.7,2.8s-1.8-1.2-1.8-2.7s0.7-2.8,1.7-2.8C317.7,67.4,318.5,68.6,318.6,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M316.8,110.9c0,1.5-0.8,2.8-1.8,2.8s-1.7-1.2-1.7-2.8c0-1.5,0.8-2.8,1.8-2.8 C316,108.2,316.8,109.4,316.8,110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M356,67.7c0,1.5-0.8,2.8-1.8,2.8s-1.7-1.2-1.7-2.8c0-1.5,0.8-2.8,1.8-2.8C355.2,64.9,356,66.2,356,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M359.8,91c0,1.5-0.8,2.8-1.8,2.8s-1.7-1.2-1.7-2.8c0-1.5,0.8-2.8,1.8-2.8C359.1,88.2,359.8,89.5,359.8,91 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M389.6,64.8c0.3,1.5-0.3,2.8-1.3,2.9s-2-1-2.2-2.5c-0.3-1.5,0.3-2.8,1.2-2.9 C388.3,62.2,389.3,63.3,389.6,64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M399.7,111.2c0.3,1.5-0.3,2.8-1.2,2.9c-1,0.1-2-1-2.2-2.5c-0.3-1.5,0.3-2.8,1.3-2.9 C398.5,108.6,399.5,109.7,399.7,111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M430.1,83.1c0.5,1.5,0.2,2.8-0.7,3.1c-0.9,0.2-2.1-0.8-2.6-2.2c-0.5-1.5-0.2-2.8,0.7-3.1 C428.4,80.7,429.6,81.7,430.1,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M448.9,118.8c0.5,1.5,0.1,2.8-0.8,3s-2.1-0.8-2.6-2.3s-0.1-2.8,0.8-3 C447.2,116.3,448.4,117.3,448.9,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFEFE",
    d: "M471.9,95.6c0.5,1.5,0.1,2.8-0.8,3s-2.1-0.8-2.6-2.3s-0.1-2.8,0.8-3S471.4,94.1,471.9,95.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat1NewHair2);
export default __webpack_public_path__ + "static/media/m-hat1_new-hair2.baeb14f9676916b40fb45ec219a12055.svg";
export { ForwardRef as ReactComponent };